import React from "react";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Skill, mySkill } from "../constant/Skills";
import "swiper/css/navigation";

interface props {
  area: string;
}
const SkillSwiper = ({ area }: props) => {
  return (
    <Swiper
      direction="horizontal"
      modules={[Autoplay]}
      slidesPerView={1}
      spaceBetween={0}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      loop={true}
      speed={1000}
      style={{
        backgroundColor: "black",
        border: "solid 2px aliceblue",
        borderRadius: "10px",
      }}>
      {mySkill
        .filter((skill) => skill.area === area)
        .map((skill: Skill, index) => {
          return (
            <SwiperSlide key={index} className="skill-swiper-slide">
              <div
                className="skill-slide-img"
                style={{
                  backgroundImage: `url("https://img.shields.io/badge/${skill.name}-${skill.color}?style=for-the-badge&logo=${skill.name}&logoColor=white")`,
                }}></div>
            </SwiperSlide>
          );
        })}
    </Swiper>
  );
};

export default SkillSwiper;
